import type { ReactNode } from 'react';
import React, { forwardRef } from 'react';

import { FlexProps } from '@rover/kibble/core';

import BaseCarousel from '../../BaseCarousel';
import { OnScrollEventHooks, ScrollMarginProperties, ScrollPaddingProperties } from '../../types';

export type Props = {
  /** The components to be rendered inside the carousel (e.g., cards) */
  children: ReactNode;
  gap?: FlexProps['gap'];
  scrollSnapAlign?: 'center' | 'start' | 'end';
  showScrollbar?: boolean;
} & ScrollMarginProperties &
  ScrollPaddingProperties &
  OnScrollEventHooks;

/**
 * A SnappingCarousel component that leverages the BaseCarousel component,
 * This component is explicitly for pagination with snapping cards into place.
 */
const SnappingCarousel = forwardRef<HTMLElement, Props>(
  ({ children, scrollSnapAlign = 'start', ...rest }, ref) => {
    return (
      <BaseCarousel
        ref={ref}
        scrollSnapAlign={scrollSnapAlign}
        scrollSnapType="x mandatory"
        scrollSnapStop="always"
        {...rest}
      >
        {children}
      </BaseCarousel>
    );
  }
);

export default SnappingCarousel;
